import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Fade from 'react-reveal/Fade';
import styles from './BestSellerSection.styles';
import BestSellerComponent from '../BestSellerComponent';
import { getTheme } from '../../../utils';

class BestSellerSection extends React.Component {
  renderBestSellersDesign = () => {
    const { sections } = this.props;
    let i = 0;
    if (!_.isEmpty(sections)) {
      return _.keys(sections)
        .sort((a, b) => sections[a].position - sections[b].position)
        .map(key => {
          const section = sections[key];
          if (section && i < 4) {
            i++;
            return (
              <div className='col-md-6 p-0 p-sm-4 py-3 py-sm-0' key={key}>
                <BestSellerComponent section={section} sectionKey={section.key} />
              </div>
            );
          }
        });
    }

    return _.map([1, 2, 3, 4], i => {
      return (
        <div className='col-md-6 p-0 p-sm-4 py-3 py-sm-0' key={i}>
          <BestSellerComponent />
        </div>
      );
    });
  };

  renderDesign0 = textColor => {
    return (
      <Fade>
        <div className='container py-5'>
          <div className='row'>
            <div className='col'>
              <h1 className={`${textColor} text-title`}>Nos Best Sellers</h1>
              <h5 className={textColor === 'text-white' ? textColor : 'text-muted'}>
                A ne surtout pas rater
              </h5>
            </div>
          </div>
          <div className='row'>{this.renderBestSellersDesign(textColor)}</div>
        </div>
      </Fade>
    );
  };

  renderDesign1 = textColor => {
    return (
      <div className='container py-5'>
        <div className='row'>
          <div className={`col ${textColor}`}>
            <h1 className='text-title'>Nos Best Sellers</h1>
            <h5 className={textColor === 'text-white' ? textColor : 'text-muted'}>
              A ne surtout pas rater
            </h5>
          </div>
        </div>
        <div className='row'>{this.renderBestSellersDesign(textColor)}</div>
      </div>
    );
  };

  renderDesign = textColor => {
    const { webapp } = this.props;
    const { landingDesign } = webapp;
    switch (landingDesign) {
      case 0:
        return this.renderDesign0(textColor);
      case 1:
        return this.renderDesign1(textColor);
      default:
        return this.renderDesign0(textColor);
    }
  };

  render() {
    const { webapp } = this.props;
    const { imageCoverUrl2 } = webapp.images;
    const { index } = this.props;
    const { style, textColor } = getTheme(index, imageCoverUrl2);
    return (
      <section className='text-center' style={style}>
        <div style={{ backgroundColor: index % 2 ? 'rgba(0,0,0,.8)' : 'white' }}>
          {this.renderDesign(textColor)}
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ shopReducer, configurationReducer }) => {
  const { sections } = shopReducer;
  const { webapp } = configurationReducer;
  return {
    sections,
    webapp
  };
};

export default connect(mapStateToProps, {})(BestSellerSection);
